import { patientAction } from '../../actions/constant';

const {
  GET_THERAPIST_SINGLE_DISCIPLINE_FAILURE,
  GET_THERAPIST_SINGLE_DISCIPLINE_SUCCESS,
  GET_THERAPIST_SINGLE_DISCIPLINE_LOADING,
} = patientAction;

const intitialstate: object = {
  response: null,
  errorResponse: null,
  loading: false,
};

export const getSingleTherapistDisciplineReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_THERAPIST_SINGLE_DISCIPLINE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        errorResponse: null,
        loading: false,
      };
    }

    case GET_THERAPIST_SINGLE_DISCIPLINE_FAILURE:
      return {
        ...state,
        response: null,
        errorResponse: action.payload,
        loading: false,
      };

    case GET_THERAPIST_SINGLE_DISCIPLINE_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
